<script lang="ts">
  import { faChevronDown } from '@itdev-fortawesome/pro-solid-svg-icons/faChevronDown';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import type { Snippet } from 'svelte';
  import Dropdown from './bootstrap/Dropdown.svelte';

  interface Props {
    title: string;
    children: Snippet;
    dropdownTglClass?: string;
    disabled?: boolean;
  }

  let { title, children, dropdownTglClass = '', disabled }: Props = $props();
</script>

<Dropdown toggleBtnClass="btn-clean {dropdownTglClass}" {disabled}>
  {#snippet toggleBtnTitle()}
    {title}<FontAwesomeIcon icon={faChevronDown} size="sm" class="ms-1" />
  {/snippet}
  {@render children()}
</Dropdown>
